import { render, staticRenderFns } from "./HereOlva.vue?vue&type=template&id=092f61dc"
import script from "./HereOlva.vue?vue&type=script&lang=js"
export * from "./HereOlva.vue?vue&type=script&lang=js"
import style0 from "./HereOlva.vue?vue&type=style&index=0&id=092f61dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports